export class LoadClub {
  static readonly type = '[Club] Load Club';

  constructor(readonly slug: string) {}
}
